import { toast } from 'sonner';

/**
 * Toast de succès pour réservation (avec bouton OK obligatoire)
 * Ne se ferme qu'après clic sur OK
 */
export const bookingSuccessToast = (message: string) => {
  toast.success(message, {
    duration: Infinity,
    dismissible: false,
    action: {
      label: 'OK',
      onClick: () => toast.dismiss()
    },
    className: 'booking-toast-success'
  });
};

/**
 * Toast d'erreur pour réservation (très visible avec bouton OK)
 * Animation shake + bordure rouge + ne se ferme qu'après clic sur OK
 */
export const bookingErrorToast = (message: string) => {
  toast.error(message, {
    duration: Infinity,
    dismissible: false,
    action: {
      label: 'OK',
      onClick: () => toast.dismiss()
    },
    className: 'booking-toast-error'
  });
};

/**
 * Toast pour annulation (succès ou info)
 * Ne se ferme qu'après clic sur OK
 */
export const cancellationToast = (message: string, variant: 'success' | 'info' = 'success') => {
  const toastFn = variant === 'info' ? toast.info : toast.success;
  
  toastFn(message, {
    duration: Infinity,
    dismissible: false,
    action: {
      label: 'OK',
      onClick: () => toast.dismiss()
    },
    className: 'booking-toast-cancellation'
  });
};
